import React from 'react'
import { Container, Modal } from 'react-bootstrap'
import { observer } from 'mobx-react'
import { GrClose } from 'react-icons/gr'
import ImageComponent from '../../ImageComponent'
import { currencyFormat, i18nTranslate } from 'src/utils'
import './styles.scss'

/**
 * FreeGiftsModal component renders a modal
 * with gifts details.
 *
 * Props:
 * - show: Boolean to show/hide modal
 * - onHide: Callback to hide modal
 * - subscriptions: Object with subscriptions data
 */
@observer
class FreeGiftsModal extends React.Component {
  render() {
    const { show, onHide, subscriptions } = this.props
    const giftsData = []
    subscriptions?.forEach(gift => {
      giftsData.push({
        name: gift?.skus?.[0]?.name || '',
        image: gift?.skus?.[0]?.skuProperties?.imageURL || '',
        qty: gift?.quantity,
        price: `${gift?.properties?.giftPurchasePrice || '0.00'}`,
      })
    })

    return (
      <Modal show={show} onHide={() => onHide()} centered>
        <Modal.Body>
          <Container>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="free-gifts-header">
                {i18nTranslate('orderCard.freeGifts', 'Free Gifts')}
              </div>
              <div className="ssm-close-icon">
                <GrClose type="button" onClick={() => onHide()} />
              </div>
            </div>
            {giftsData.map((gift, index) => (
              <div key={index} className="d-flex mb-3">
                <div className="p-2">
                  {/* <img
                    src={gift?.image}
                    alt={gift?.name}
                    className="free-gift-image"
                  /> */}
                  <ImageComponent
                    width="86px"
                    height="86px"
                    optimizeImage={true}
                    src={gift?.image}
                    alt={gift?.name}
                    className="free-gift-image"
                    data-testid="qa-free-gift-image"
                  />
                </div>
                <div className="p-2 flex-grow-1">
                  <span
                    className="free-gift-name"
                    data-testid="qa-subscription-free-gift-name">
                    {gift?.name}
                  </span>
                  <span
                    className="free-gift-qty"
                    data-testid="qa-subscription-free-gift-qty">
                    QTY: {gift?.qty}
                  </span>
                  <span
                    className="free-gift-price"
                    data-testid="qa-subscription-free-gift-price">
                    {currencyFormat({
                      price: 0,
                    })}
                  </span>
                </div>
              </div>
            ))}
          </Container>
        </Modal.Body>
      </Modal>
    )
  }
}

export { FreeGiftsModal }
export default FreeGiftsModal
